<script>
  import {LINKS, SERVICES, IMAGES_V2} from '@/const';
  import {envUtil} from '@/helper/env';
  import {lang$} from '@/store';

  const PREFIX = `${SERVICES.STATIC_URL}/s/web/media/`;
  const IMAGES = {
    FACEBOOK: PREFIX + 'facebook.svg',
    TWITTER: 'https://img.phemex.com/v1/c80f707e-e491-410c-b9ed-e28fdf5e3d6c/twitter.svg',
    TELEGRAM: PREFIX + 'telegram.svg',
    YOUTUBE: PREFIX + 'youtube.svg',
    MEDIUM: PREFIX + 'medium.svg',
    VK: PREFIX + 'vk.svg',
    KAKAO: PREFIX + 'kakao.svg',
    NAVER: PREFIX + 'naver.svg',
    WECHAT: PREFIX + 'wechat.svg',
    MICROBLOG: PREFIX + 'microblog.svg',
    LINKIN: PREFIX + 'linkin.svg',
    SNAPCHAT: PREFIX + 'snapchat.svg',
    INSTAGRAM: PREFIX + 'instagram.svg',
    DISCORD: PREFIX + 'discord.svg',
    TIKTOK: PREFIX + 'tiktok.svg',
  };
  const IMAGESNEW = {
    FACEBOOK: 'https://img.phemex.com/v1/9bacd9ae-bb47-40bc-be80-41b2cd494a8a/facebook-color-off.svg',
    TWITTER: 'https://img.phemex.com/v1/3db97352-1af3-44a2-956c-ad4016aa34a3/x-twitter-color-off.svg',
    TELEGRAM: 'https://img.phemex.com/v1/e8cf5194-772f-47c2-b512-58e8bb5bc5c2/telegram-color-off.svg',
    YOUTUBE: 'https://img.phemex.com/v1/08335614-5c11-4e44-ab2b-cee1c90ddd0c/youtube-color-off.svg',
    MEDIUM: PREFIX + 'medium.svg',
    VK: PREFIX + 'vk.svg',
    KAKAO: PREFIX + 'kakao.svg',
    NAVER: PREFIX + 'naver.svg',
    WECHAT: PREFIX + 'wechat.svg',
    MICROBLOG: PREFIX + 'microblog.svg',
    LINKIN: 'https://img.phemex.com/v1/9ccf2acb-1ff9-4b7c-a598-6a8335032414/linkedin-color-off.svg',
    SNAPCHAT: PREFIX + 'snapchat.svg',
    INSTAGRAM: 'https://img.phemex.com/v1/39b20893-1c58-43e3-bd1a-f90bad4273f7/instagram-color-off.svg',
    DISCORD: 'https://img.phemex.com/v1/7b9db7cf-eec3-4251-b0b9-9fd7f306c4bb/discord-color-off.svg',
    TIKTOK: PREFIX + 'tiktok.svg',
    TV: 'https://img.phemex.com/v1/4986abf1-6ec9-436b-8701-b5a53c1b77ff/trading-view-track-all-markets.svg'
  };
  const defaultLinks = {
    FACEBOOK: {url: LINKS.PHEMEX_FACEBOOK, img: IMAGESNEW.FACEBOOK, alt: 'Facebook'},
    TWITTER: {url: LINKS.PHEMEX_TWITTER, img: IMAGESNEW.TWITTER, alt: 'Twitter'},
    TELEGRAM: {url: LINKS.PHEMEX_TELEGRAM, img: IMAGESNEW.TELEGRAM, alt: 'Telegram'},
    LINKIN: {url: LINKS.PHEMEX_LINKEDIN, img: IMAGESNEW.LINKIN, alt: 'linkedin'},
    YOUTUBE: {url: LINKS.PHEMEX_YOUTUBE, img: IMAGESNEW.YOUTUBE, alt: 'Youtube'},
    INSTAGRAM: {url: LINKS.PHEMEX_INSTAGRAM_EN, img: IMAGESNEW.INSTAGRAM, alt: 'Instagram'},
    DISCORD: {url: LINKS.PHEMEX_DISCORD, img: IMAGESNEW.DISCORD, alt: 'Discord'},
    TV: {url: LINKS.PHEMEX_TV, img: IMAGESNEW.TV, alt: 'tradeView'},
  };
  const links = {
    en: Object.values(defaultLinks),
    ru: [
      {url: LINKS.PHEMEX_TWITTER_RU, img: IMAGES.TWITTER, alt: 'Twitter'},
      {url: LINKS.PHEMEX_TELEGRAM_RU, img: IMAGES.TELEGRAM, alt: 'Telegram'},
      defaultLinks.YOUTUBE,
      {url: LINKS.PHEMEX_VK_RU, img: IMAGES.VK, alt: 'Vk'},
      {url: LINKS.PHEMEX_INSTAGRAM_RU, img: IMAGES.INSTAGRAM, alt: 'Instagram'},
      defaultLinks.TV,
    ],
    ko: [
      {url: LINKS.PHEMEX_FACEBOOK_KO, img: IMAGES.FACEBOOK, alt: 'Facebook'},
      {url: LINKS.PHEMEX_TWITTER, img: IMAGES.TWITTER, alt: 'Twitter'},
      {url: LINKS.PHEMEX_TELEGRAM_KO, img: IMAGES.TELEGRAM, alt: 'Telegram'},
      defaultLinks.YOUTUBE,
      {url: LINKS.PHEMEX_KAKAO_KO, img: IMAGES.KAKAO, alt: 'Kakao'},
      {url: LINKS.PHEMEX_NAVER_KO, img: IMAGES.NAVER, alt: 'Naver'},
      defaultLinks.TV,
    ],
    ja: [{url: LINKS.PHEMEX_TWITTER_PULSE, img: IMAGES.TWITTER, alt: 'Twitter'}],
    es: [
      {url: LINKS.PHEMEX_FACEBOOK_ES, img: IMAGES.FACEBOOK, alt: 'Facebook'},
      {url: LINKS.PHEMEX_TWITTER_ES, img: IMAGES.TWITTER, alt: 'Twitter'},
      {url: LINKS.PHEMEX_TELEGRAM_ES, img: IMAGES.TELEGRAM, alt: 'Telegram'},
      {url: LINKS.PHEMEX_LINKEDIN, img: IMAGES.LINKIN, alt: 'linkedin'},
      {url: LINKS.PHEMEX_MEDIUM, img: IMAGES.MEDIUM, alt: 'Medium'},
      {url: LINKS.PHEMEX_INSTAGRAM_ES, img: IMAGES.INSTAGRAM, alt: 'Instagram'},
      defaultLinks.TV,
    ],
    de: [
      {url: LINKS.PHEMEX_FACEBOOK_DE, img: IMAGES.FACEBOOK, alt: 'Facebook'},
      {url: LINKS.PHEMEX_TWITTER_DE, img: IMAGES.TWITTER, alt: 'Twitter'},
      {url: LINKS.PHEMEX_TELEGRAM_DE, img: IMAGES.TELEGRAM, alt: 'Telegram'},
      defaultLinks.YOUTUBE,
      {url: LINKS.PHEMEX_MEDIUM, img: IMAGES.MEDIUM, alt: 'Medium'},
      {url: LINKS.PHEMEX_INSTAGRAM_DE, img: IMAGES.INSTAGRAM, alt: 'Instagram'},
      defaultLinks.TV,
    ],
    fr: [
      defaultLinks.FACEBOOK,
      {url: LINKS.PHEMEX_TWITTER_FR, img: IMAGES.TWITTER, alt: 'Twitter'},
      defaultLinks.TELEGRAM,
      defaultLinks.YOUTUBE,
      defaultLinks.LINKIN,
      defaultLinks.DISCORD,
      defaultLinks.INSTAGRAM,
      defaultLinks.TV,
    ],
    tr: [
      defaultLinks.FACEBOOK,
      {url: LINKS.PHEMEX_TWITTER_TR, img: IMAGES.TWITTER, alt: 'Twitter'},
      {url: LINKS.PHEMEX_TELEGRAM_TR, img: IMAGES.TELEGRAM, alt: 'Telegram'},
      {url: LINKS.PHEMEX_INSTAGRAM_TR, img: IMAGES.INSTAGRAM, alt: 'Instagram'},
      defaultLinks.TV,
    ],
    pt: [
      defaultLinks.FACEBOOK,
      {url: LINKS.PHEMEX_TWITTER_PT, img: IMAGES.TWITTER, alt: 'Twitter'},
      {url: LINKS.PHEMEX_TELEGRAM_PT, img: IMAGES.TELEGRAM, alt: 'Telegram'},
      defaultLinks.LINKIN,
      defaultLinks.YOUTUBE,
      defaultLinks.INSTAGRAM,
      defaultLinks.DISCORD,
      defaultLinks.TV,
    ],
    vi: [
      {url: LINKS.PHEMEX_FACEBOOK_VI, img: IMAGES.FACEBOOK, alt: 'Facebook'},
      {url: LINKS.PHEMEX_TWITTER_VI, img: IMAGES.TWITTER, alt: 'Twitter'},
      {url: LINKS.PHEMEX_TELEGRAM_VI, img: IMAGES.TELEGRAM, alt: 'Telegram'},
      {url: LINKS.PHEMEX_INSTAGRAM_VI, img: IMAGES.INSTAGRAM, alt: 'Instagram'},
      defaultLinks.TV,
    ],
  };

  $: items = envUtil.isJapanSite ? links.ja : links[$lang$] || [];
</script>

<style>
  .media img:hover {
    opacity: 0.8;
  }
  .gap-16 {
    gap: 16px;
  }
  @media screen and (max-width: 640px) {
    .media {
      gap: 10px;
    }
    .media a.ga img {
      width: 20px;
      height: 20px;
    }
  }
</style>

<slot {items}>
  <div class="media df gap-16 fww">
    {#each items as item, i (item.alt)}
      <a class="ga" data-action="footerlink" data-label="footerlink.{item.alt}" target="_blank" rel="noopener noreferrer nofollow" href={item.url}>
        <img width="28" height="28" class="lazyload" data-src={item.img} alt={item.alt} />
      </a>
    {/each}
  </div>
</slot>
